<script>
    export let willLoop = false;
    export let audioName;
    export let audioUrl;
    let player;

    // <source src='https://sveltejs.github.io/assets/music/strauss.mp3'>
</script>

{#if audioUrl}
    <figure id="replay-element">
        <figcaption class="sensor-data-title">{"Listen to " + audioName}</figcaption>
        {#key audioUrl}
            <audio bind:this={player} src={audioUrl} controls loop={willLoop}>
                <track kind="captions" />
                on:loadeddata={() => console.log('Audio loaded')}
                on:error={(e) => console.log('Audio error', e)}
            </audio>
        {/key}
    </figure>
{/if}
  
<style>
    audio {
        height: 48px;
        margin: 4px;
    }
    figcaption {
        /* margin-bottom: 8px; */
        white-space: nowrap;
        width: auto;
    }
    #replay-element {
        /* text-align: center; */
        margin: 16px;
        display: flex;
        align-items: center;
        gap: 10px;
    }
</style>